import navigate from '~/mixins/navigate'

export default {
  mixins: [navigate],

  methods: {
    scrollPosition(anchorId) {
      const element = document.getElementById(anchorId)
      if (!element) return

      const elementTop = element.getBoundingClientRect().top + window.pageYOffset

      window.scrollTo({
        top: elementTop,
        behavior: 'smooth',
      })
    },

    handleClick() {
      const anchorIndex = this.computedHref.indexOf('#')
      if (anchorIndex === -1) return
      const anchorId = this.computedHref.substr(anchorIndex + 1)

      const currentUrl = new URL(window.location.href)

      if (currentUrl.href === this.computedHref.split('#')[0] || currentUrl.hash) {
        this.scrollPosition(anchorId)
      } else {
        window.location.href = this.computedHref
      }
    },
  },
}
